import React from 'react';
import { PlayStoreImage, PlayStoreLink } from './StoreLogos.styled';

export const PlayStoreLogo = () => (
  <PlayStoreLink href="https://play.google.com/store/apps/details?id=com.ublendreact&hl=en&gl=US&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
    <PlayStoreImage alt="Get it on Google Play" />
  </PlayStoreLink>
);
